import styled from "styled-components";
import { FaInfoCircle } from "react-icons/fa";
import { PrimaryButton } from "components/Button/style";

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding: 0;
  margin: 0;
`;

export const IconeInfo = styled(FaInfoCircle)`
  color: ${({ theme }) => theme.colors.project.main};
  margin-bottom: 3px;
`;

export const BotoesContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1.67rem;
`;

export const BotaoFiltroCampo = styled(PrimaryButton)`
  width: 2.3rem;
  padding: 0;
  border-radius: 0 5px 5px 0;
  background-color: ${({ theme }) => theme.colors.project.main};
  border-color: ${({ theme }) => theme.colors.project.main};
`;

export const MaisFiltrosContainer = styled.div`
  position: relative;
  padding-top: 1.4rem;
  display: flex;
  justify-content: end;
`;

export const MaisFiltrosDropdownWrapper = styled.div`
  /* Aumenta só o dropdown interno sem afetar o layout do grid */
  & > div > div:last-child {
    min-width: 340px;
    width: auto !important;
  }
`;

export const CampoMaisFiltros = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  display: grid;
  height: 60px;
`;
